<template>
  <div data-track="Review Invitations Sends">
    <div class="invite-sends">
      <div class="invite-section">
        <p class="customer-head-text">Add your customers</p>
        <p class="customer-desc">
          Add customers to your send queue by providing their name and
          email address. You can also send an additional SMS invite by
          including their mobile number. Mobile numbers are not mandatory
          and SMS invites do not count as an additional review invitation.
        </p>
        <div class="buttons manage-csv-btn is-hidden-mobile">
          <p class="customer-head">Bulk upload</p>
          <p class="download-desc">Upload a CSV file, <a :href="getTemplateUrl" class="has-text-underlined color-2aabe1 margin-top-20 margin-bottom-20" download>download our template</a> for guidance</p>
          <div class="file-upload-section " :class="{'disabled':!canUploadCsv}">
            <vue-dropzone ref="uploadField"  id="dropzone" :options="dropzoneOptions" data-track="review invite upload csv file to dropzone" :useCustomSlot=true @vdropzone-file-added="uploadCsv" @vdropzone-error="errorHandle">
              <img src="/static/img/upload-file-icon.png" />
              <p class="dropzone-custom-title">Drag and drop here or <a>select a file</a></p>
            </vue-dropzone>
            <a href="" ref="errorFileDownLink" target="_blank" download class="is-hidden"></a>
          </div>
        </div>
        <p class="help is-danger" v-if="csvError" v-text="csvError"></p>
        <div class="border-or is-hidden-mobile"><span>or</span></div>
        <div class="email-parent margin-bottom-20 margin-top-8">
          <p class="customer-head">Add individual customer</p>
          <div class="control input-firstname">
            <label>First name</label>
            <input class="input"
                   name="contact_firstname"
                   placeholder="First name"
                   type="text"
                   v-model="inputFirstname"/>
          </div>
          <div class="control input-mobile">
            <label class="is-flex">Mobile Number <span>(optional)</span>
              <tooltip-new style="margin-left: 5px; vertical-align: text-top;" content-width="350px" :v2="true">
                If you add a mobile number, your customer will receive an SMS invite in addition to an email invite.
                This significantly increases your ability to turn a review invite into a review.<br/>
                <strong>Note - Even though two invites are sent to one customer, only one review invite will be deducted from your review invite quota.</strong>
              </tooltip-new>
            </label>
            <input class="input"
                   name="contact_number"
                   placeholder="000 000 0000"
                   type="tel"
                   v-model="inputNumber"/>
          </div>
          <div class="control input-email">
            <label>Email address</label>
            <input class="input"
                   name="contact_email"
                   placeholder="Email address"
                   type="text"
                   v-model="inputEmail"/>
          </div>
          <div class="buttons">
            <button :class="['button is-hidden-mobile ', { 'is-loading': addingManual }, {'is-button-blue': canAddInvite }]"
                    :disabled="!canAddInvite"
                    @click.prevent="addInvite"
                    data-track="add review invite">ADD TO QUEUE
            </button>
            <button
              :class="['button is-hidden-tablet is-fullwidth margin-top-0', { 'is-loading': addingManual }, {'is-button-blue': canAddInvite }]"
              :disabled="!canAddInvite"
              @click.prevent="addInvite"
              data-track="add review invite">ADD TO QUEUE
            </button>
          </div>
        </div>
      </div>

      <div class="invite-list">
        <div class="columns">
          <div class="column is-6-mobile is-8-desktop is-10-widescreen padding-left-0 p-y-0">
            <p class="customer-head-text">Send queue <span class="queue-sent" v-if="responseMsg">
              <i class="fa fa-check" aria-hidden="true"></i> {{responseMsg}} customer{{responseMsg && responseMsg > 1 ? 's' : ''}} added to queue</span>
              <span v-if="failedFilesMsg" class="queue-not-added"><i class="fa fa-times" aria-hidden="true"></i>&nbsp; {{failedFilesMsg}} not added <span style="color:grey;">-&nbsp;</span><a href="javascript:void(0);" @click="$refs.errorFileDownLink.click()" class="error-download-link">download error file</a></span>
            </p>
          </div>
          <div class="column is-4-mobile padding-right-0 padding-left-0 p-y-0 has-text-right">
            <button data-track="send review invites now" class="button" type="button" :disabled="!canSendInvite" :class="[{'is-loading': sendingInvites}, {'is-disabled': !canSendInvite}, {'is-button-blue': canSendInvite}]" @click.prevent="sendInvites">SEND INVITES</button>
          </div>
        </div>
        <p v-resultsCount="total_records"></p>
        <div class="has-text-centered" v-if="fetching_data">
          <p class="tag is-warning">
            <i class="fa fa-spinner fa-spin"></i>
            &nbsp;Fetching queue...
          </p>
        </div>
        <div class="level">
          <table class="table is-size-7-touch is-marginless">
            <thead class="row-bordered-line">
              <tr>
                <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-grey">Date added</td>
                <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-grey">Name</td>
                <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-grey">Email</td>
                <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-grey">Mobile number</td>
                <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-grey">Submission type</td>
                <td class="is-narrow-mobile pad35-desktop is-desktop is-size-7-desktop has-text-grey"></td>
              </tr>
            </thead>
            <tbody>
            <tr class="margin-bottom-30 all-review-sent-invitation" v-if="invitationStats['pending'] < 1 && isVisibleAllReviewInviteNotify">
              <td class="is-narrow-mobile is-size-7-touch all-review-sent-notify" colspan="5">
                You have already sent out all available review invitations.
              </td>
              <td class="is-narrow-mobile is-desktop">
                <img class="times-circle" @click="isVisibleAllReviewInviteNotify = !isVisibleAllReviewInviteNotify" src="/static/img/cancel_clear.svg" />
              </td>
            </tr>
            <tr v-if="isReviewSentSuccessfully && invitesSentCount" class="no-record-row">
              <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-grey"
                  colspan="8">
                <p class="has-text-centered bordered-line"></p>
                <div class="success-invite-section">
                  <div class="success-img-section">
                    <img src="/static/img/success_thumbs_up.png" />
                  </div>
                  <div class="success-content-section">
                    <p class="color-2aabe1 is-size-5 congrats-text">Congrats!</p>
                    <p class="success-invites-msg">You have successfully sent out {{invitesSentCount}} review invitations.</p>
                    <p v-if="!invitesFailedCount" class="success-invites-link">Now check how they're doing  <router-link to="/collect-reviews/review-invites/history" class="has-text-underlined color-2aabe1">here</router-link></p>
                    <p class="review-not-sent-msg" v-if="invitesFailedCount">
                      <span class="has-text-weight-bold">{{invitesFailedCount}} review invites were not sent </span>, because all review invites on your package have been used.
                      Customers that did not get a review invitation will remain in your send queue until more review invites become available.
                    </p>
                  </div>
                  <div class="close-invite-success">
                    <span>
                      <img class="times-circle" @click="isReviewSentSuccessfully=!isReviewSentSuccessfully" src="/static/img/cancel_clear.svg" />
                    </span>
                  </div>
                </div>

              </td>
            </tr>
            <template v-if="items.length">

              <tr class="margin-bottom-20 row-bordered-line"  v-for="(invite, index) in items">
                <td class="is-narrow-mobile is-size-7-touch">{{ invite.created_at | prettyDateTime}}</td>
                <td class="is-size-7-mobile is-size-7-touch invite-first-name">{{ invite.first_name }}</td>
                <td class="is-narrow-mobile is-size-7-touch invite-email-address">{{invite.email}}</td>
                <td class="is-narrow-mobile is-size-7-touch">
                  <template v-if="'mobile' in invite && invite.mobile">
                    {{invite.mobile}}
                  </template>
                  <template v-else>Not provided</template>
                </td>
                <td class="is-narrow-mobile is-size-7-touch">
                  {{ selectedTemplate === 'INMAIL' ? 'In-mail' : 'Landing page' }}
                </td>
                <td class="is-narrow-mobile is-desktop">
                  <a data-track="remove review invite" class="has-text-underlined color-2aabe1" href="#" @click.prevent="removeInvite(invite.id)" :class="{'disabled':(!canRemoveInvite || invitesToRemove.includes(invite.id))}">
                    <img class="times-circle" src="/static/img/cancel_clear.svg" />
                  </a>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <div class="level pagination-section">
          <paginator :dataSet="dataSet" :keyword_string="keyword_string" @changed="getInviteList" :isNewPaginationActive="true"></paginator>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import axios from 'axios'
  import Misc from './../../mixins/misc.js'
  import Paginator from '../../components/Paginator.vue'
  import {TooltipNew} from '@/widgets'

  export default {
    components: {
        Paginator,
        vueDropzone: vue2Dropzone,
        TooltipNew
    },
    metaInfo: {
      title: 'Business Portal | Hellopeter - Review Invites send'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Review Invites send'
      })
    },
    name: 'ReviewInviteSends',
    mixins: [Misc],
    data () {
      return {
        dataSet: {},
        total_records: 0,
        keyword_string: undefined,
        items: [],
        invitesToRemove: [],
        invitationStats: [],
        bizId: localStorage.org_id,
        bizSlug: localStorage.org_slug,
        inputEmail: '',
        inputFirstname: '',
        inputNumber: '',
        csvError: '',
        uploadField: '',
        fetching_data: false,
        sendingInvites: false,
        addingManual: false,
        uploading: false,
        removingInvite: false,
        dropzoneOptions: {
          url: 'https://httpbin.org/post',
          thumbnailWidth: 150,
          maxFilesize: 0.5,
          maxFiles: 1,
          headers: { 'My-Awesome-Header': 'header value' },
          autoProcessQueue: false,
          addRemoveLinks: true,
          uploadMultiple: true,
          acceptedFiles: 'application/csv, text/csv'
        },
        responseMsg: '',
        failedFilesMsg: '',
        isReviewSentSuccessfully: false,
        invitesSentCount: 0,
        invitesFailedCount: 0,
        isVisibleAllReviewInviteNotify: true
      }
    },
    created () {
      this.getInviteList()
    },
    computed: {
      /*
       * get template url
       *
       * @returns string
       */
      getTemplateUrl () {
        if (this.subscription === 'Free') {
          return `/static/assets/invite_template_free.csv`
        }
        return `/static/assets/invite_template_pro.csv`
      },
      canAddInvite () {
        let numbValid = true
        if (this.inputNumber.length) {
          let regex = /^\d{10}$/
          numbValid = regex.test(this.inputNumber)
        }
        return !this.fetching_data && !this.sendingInvites && !this.addingManual && !this.uploading && this.inputEmail.length && this.inputFirstname.length && this.verifyEmail(this.inputEmail) && numbValid
      },
      canRemoveInvite () {
        return !this.fetching_data && !this.sendingInvites
      },
      canUploadCsv () {
        return !this.fetching_data && !this.sendingInvites && !this.addingManual && !this.uploading
      },
      canSendInvite () {
        return this.items.length && !this.removingInvite && !this.sendingInvites && !this.addingManual && !this.uploading && this.invitationStats['pending']
      },
      subscription () {
        const subscriptionDetails = localStorage.billingDetails ? JSON.parse(localStorage.billingDetails) : ''
        if (subscriptionDetails) {
          return subscriptionDetails.subscription.name
        }
        return ''
      }
    },
    methods: {
      getInviteList (page = 0) {
        this.fetching_data = true

        if (!page) {
          let query = location.search.match(/page=(\d+)/)
          page = query ? query[1] : 1
        }
        axios.get(`/${this.bizId}/review-invites?page=${page}`)
          .then(response => {
            this.refresh(response)
            this.invitationStats = response.data.invitationStats
            this.selectedTemplate = response.data.selectedTemplate
            this.fetching_data = false
          })
          .catch(error => {
            this.fetching_data = false
            this.displayErrMsg(error, 'Failed to load review invitation queue records', `Failed to load records`)
          })
      },
      addInvite () {
        this.addingManual = true
        const formData = {
          firstName: this.inputFirstname,
          email: this.inputEmail,
          number: this.inputNumber
        }
        if (this.subscription !== 'Free') {
          formData.number = this.inputNumber
        }
        axios.post(`/${this.bizId}/review-invites`, formData)
          .then(() => {
            this.inputFirstname = ''
            this.inputEmail = ''
            this.inputNumber = ''
            this.addingManual = false
            this.responseMsg = 1
            this.isReviewSentSuccessfully = false
            // this.displaySuccessMsg(`Added to queue successfully`, 'Successfully manually added review invitation to queue')
            this.getInviteList(1)
          })
          .catch(error => {
            this.addingManual = false
            this.responseMsg = ''
            this.failedFilesMsg = ''
            this.isReviewSentSuccessfully = false
            this.displayErrMsg(error, 'Failed to manually added review invitation to queue', `Failed to add to queue`)
          })
      },
      removeInvite (id) {
        this.removingInvite = true
        this.invitesToRemove.push(id)
        axios.delete(`/${this.bizId}/review-invites/${id}`)
          .then(() => {
            this.removingInvite = false
            this.displaySuccessMsg(`Removed from queue successfully`, 'Successfully removed review invitation from queue')
            this.getInviteList()
          })
          .catch(error => {
            this.removingInvite = false
            this.displayErrMsg(error, 'Failed to remove review invitation from queue', `Failed to remove from queue`)
          })
      },
      errorHandle (file) {
        this.$refs.uploadField.removeAllFiles()
      },
      uploadCsv (file) {
        this.csvError = ''
        this.uploading = true
        let formData = new FormData()
        formData.append('file', file)
        axios.post(`/${this.bizId}/review-invites/upload-csv`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(({data}) => {
            this.$refs.uploadField.value = ''
            this.uploading = false
            this.isReviewSentSuccessfully = false
            this.responseMsg = data.recordsAdded
            this.failedFilesMsg = data.recordsFailed
            // this.displaySuccessMsg(`${data.recordsAdded} records added to your queue, ${data.recordsFailed} records failed`, 'Successfully bulk added review invitation to queue')
            this.getInviteList(1)

            if (data.recordsFailed) {
              let csv = ['FIRST_NAME,EMAIL_ADDRESS,ERROR']
              data.faultyRecords.forEach(row => {
                row = row.join(',')
                csv.push(row)
              })
              csv = csv.join('\n')

              const fileName = file.name.split('.')
              fileName.pop()
              this.$refs.errorFileDownLink.download = `${fileName}_error.csv`
              this.$refs.errorFileDownLink.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
              // this.$refs.errorFileDownLink.click()
              this.$refs.uploadField.removeAllFiles()
            }
          })
          .catch(error => {
            this.isReviewSentSuccessfully = false
            this.$refs.uploadField.value = ''
            this.uploading = false
            this.displayErrMsg(error, 'Failed to upload CSV for review invite queue', `Failed to upload the file`)
          })
      },
      sendInvites () {
        this.sendingInvites = true
        axios.post(`/${this.bizId}/review-invites/send-invites`, {
          bizSlug: this.bizSlug
        })
          .then(({data}) => {
            this.responseMsg = ''
            this.failedFilesMsg = ''
            this.isReviewSentSuccessfully = true
            this.sendingInvites = false
            this.invitesSentCount = data.sent
            if (data.sent === data.toSend) {
              this.displaySuccessMsg(`All review invitations successfully sent.`, 'Successfully sent all review invitations')
            } else {
              this.invitesFailedCount = data.toSend - data.sent
              this.displaySuccessMsg(`${data.sent} review invitations successfully sent. ${data.toSend - data.sent} not sent because the total number of review invites available on your package has been reached.`, 'Successfully sent review invitations with some unsent invitations')
            }

            this.getInviteList(1)
          })
          .catch(error => {
            this.sendingInvites = false
            this.displayErrMsg(error, 'Failed sending Review Invitations on Collect Reviews View', `Failed to send review invitations`)
          })
      }
    }
  }
</script>

<style scoped>
  .level:not(:last-child) {
    margin-bottom: 0;
  }

  .router-link-active {
    background: none !important;
  }

  .manage-csv-btn {
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    margin-top: 10px;
  }

  .manage-csv-btn div, .manage-csv-btn p {
    display: block;
  }

  .input-email input, .input-mobile input, .input-firstname input {
    height: 35px;
  }

  .italic-style {
    font-size: 0.875em;
  }

  .email-parent {
    display: flex;
    flex-direction: column;
    position: relative;
    top:20px;
  }

  .email-parent .buttons {
    width: 384px;
  }

  .invite-sends {
    margin-top: 28px;
    display: flex;
  }
  .invite-section {
    flex: 1;
    padding-right: 19.5px;
    border-right: 1px solid rgba(138, 140, 145, 0.32);
  }
  .invite-list {
    flex: 2;
    padding: 0px 0px 0px 21.5px;
    position: relative;
  }

  .invite-list button {
    color: #fff;
    width: 150px;
    height: 35px;
    border: none !important;
  }

  .is-button-blue:hover {
    background-color: #31AAE1 !important;
  }

  .invite-list button.is-disabled {
    background-color: #cdcbcb;
  }

  .customer-head, .email-parent label {
    font-size: 12px;
    height: 17px;
    line-height: 1.67;
    color: #58595b;
    font-weight: bold;
    width: 384px;
  }
  .email-parent label span {
    font-weight: 400 !important;
  }
  .control label {
    display: block;
  }
  .email-parent input {
    margin-top: 6px !important;
    width: 384px !important;
    font-size: 12px;
  }
  .border-or {
    position: absolute;
    width: 384px;
    border-top: 1px solid rgba(138, 140, 145, 0.32);
    margin-top: 17px !important;
  }
  .border-or span {
    position: absolute;
    left: 47%;
    top: -11px;
    width: 31px;
    height: 17px;
    background: #fff;
    text-align: center;
    font-size: 12px;
  }
  .email-parent > div, .email-parent > p {
    margin-bottom: 15px !important;
  }
  .customer-head-text {
    height: 19px;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #58595b;
    margin-bottom: 4px;
  }
  .customer-head-text span.queue-sent {
    font-size: 11px !important;
    margin-left: 25.9px !important;
    color: #17be86;
    line-height: 15px;
    font-weight: normal;
  }
  .customer-head-text span.queue-not-added {
    font-size: 11px !important;
    margin-left: 11.8px;
    margin-right: 5px;
    color: #d51f1f;
    line-height: 15px;
    font-weight: normal;
  }
  .customer-head-text a.error-download-link {
    font-size: 11px !important;
    margin-left: 4.5px !important;
    color: #30aae1;
    line-height: 15px;
    font-weight: normal;
    text-decoration: underline !important;
  }
  .customer-desc {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.42;
    letter-spacing: normal;
    color: #707070;
  }
  .download-desc {
    width: 384px;
    font-size: 12px;
    margin-top: 5px;
  }
  .file-upload-section {
    width: 384px;
    position: relative;
    margin-top: 7px;
  }
  .file-upload-section .dropzone {
    min-height: 0px !important;
    border: solid 1px rgba(112, 112, 112, 0.3);
    background-color: rgba(243, 243, 243, 0.4);
  }
  .file-upload-section .dropzone .dz-message {
    margin: 0px !important;
  }
  .file-upload-section .dropzone-custom-title {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.42;
    letter-spacing: normal;
    text-align: center;
    color: #58595b;
  }
  div.email-parent div.buttons {
    position: relative;
  }
  .email-parent button:not(.is-button-blue) {
    position: absolute;
    right: 0;
    top: 3px;
    margin-right: 0px !important;
    border: 1px solid #58595b;
    width: 150px;
    height: 35px;
  }

  .email-parent button.is-button-blue {
    position: absolute;
    right: 0;
    top: 3px;
    margin-right: 0px !important;
    border: none;
    width: 150px;
    height: 35px;
  }

  @media (max-width: 768px) {
    .invite-sends {
      flex-direction: column;
    }
    .email-parent .buttons {
      width: 288px;
    }
  }

  .no-record-row td p.bordered-line, .no-record-row td {
    border-top: 1px solid #dbdbdb !important;
    padding: 0 !important;
    border-bottom: none !important;
  }
  thead.row-bordered-line, tr.row-bordered-line {
    border-bottom: 1px solid #dbdbdb !important;
  }
  .table > tbody > tr {
    background: none !important;
  }

  img.times-circle {
    float: right;
    cursor: pointer;
  }
  .fa-times {
    position: relative;
  }
  .success-invite-section {
    display: flex;
    background-color: rgba(243, 243, 243, 0.4);
  }
  .success-img-section {
    padding: 8px;
  }
  .congrats-text {
    font-weight: normal;
  }
  .success-content-section {
    padding: 26px 0px 0px 32px;
    width: 74%;
  }
  .success-content-section .success-invites-msg, .success-content-section .success-invites-link {
    font-size: 14px;
  }
  .success-invites-link {
    margin-top: 30px;
  }
  .close-invite-success {
    margin: 15px 10px auto auto;
  }
  .invite-list .has-text-right {
    position: relative;
    right: 26px;
  }
  .review-not-sent-msg {
    position: relative;
    top: 38px;
  }
  .invite-first-name {
    max-width: 135px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis !important;
  }
  .invite-email-address {
    max-width: 140px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis !important;
  }
  .all-review-sent-notify {
    text-align: center;
  }
  .pagination-section {
    position: absolute;
    bottom: -29px;
    right: 0;
  }
  .table td, .table th {
    border-bottom: none !important;
  }
  .level table {
    width: 99%;
  }
  .table tbody td, .table thead th, .table thead td {
    font-size: 12px !important;
  }
  tbody tr.all-review-sent-invitation {
    background: rgba(243, 243, 243, 0.4) !important;
  }
</style>
<style>
  .file-upload-section .dropzone .dz-message {
    margin: 0;
  }
  .file-upload-section .dropzone .dz-preview {
    vertical-align: top !important;
    height: 66px !important;
    top: 3px;
    width: 91px;
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/collect-reviews/ReviewInviteSends.vue